import React from 'react';
import styled from 'styled-components';
import Carousel from '@components/shared/Carousel';
import { P } from '@components/shared/Typography';
import { PageSlice } from '@contracts';

const carouselOptions = {
  autoPlay: 4000,
  groupCells: false,
  pauseAutoPlayOnHover: true,
  cellAlign: 'center',
  draggable: true,
  pageDots: true
};

interface Props {
  slice: PageSlice;
}

const TestimonialsSlider: React.FC<Props> = ({ slice }) => (
  <Container $backgroundColor={slice.primary?.background_color}>
    <CarouselWrap>
      <Carousel options={carouselOptions}>
        {slice.items?.map((item, index) => (
          <CarouselItem key={index}>
            <Text $textColor={slice.primary?.text_color}>{item.review_text.text}</Text>
            <Cite $textColor={slice.primary?.text_color}>{item.review_cite.text}</Cite>
          </CarouselItem>
        ))}
      </Carousel>
    </CarouselWrap>
  </Container>
);

export default TestimonialsSlider;

interface StyleProps {
  $backgroundColor?: string;
  $textColor?: string;
}

const Container = styled.div<StyleProps>`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  margin: 0 auto 40px;
  padding: 30px 0 60px;
  column-gap: 40px;
  background-color: ${(props) => props.$backgroundColor};

  p {
    max-width: 863px;
  }

  @media (max-width: 1200px) {
    flex-direction: column;
    margin-bottom: 20px;
  }
`;

const CarouselWrap = styled.div`
  width: 100%;
`;

const CarouselItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  row-gap: 20px;
  padding: 20px 30px;
`;

const Text = styled(P)<StyleProps>`
  color: ${(props) => props.$textColor};
  font-family: 'Domaine';
  font-size: 42px;
  font-weight: normal;
  line-height: 50px;
  letter-spacing: -0.02em;
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 24px;
    line-height: 29px;
  }
`;

const Cite = styled(P)<StyleProps>`
  color: ${(props) => props.$textColor};
  font-family: BrownStd;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0;
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 16px;
    line-height: 24px;
  }
`;
